export default __webpack_public_path__ + "static/media/logo_interactive_2.7f11b89a.png";